import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { Link } from "react-router-dom";
import {
  ManageCompanyLayout,
  CsplTable as Table,
  FieldButtonGroup,
  FieldInput,
} from "../../components";
import AddToolTip from "../AddToolTip";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { SliderPanel } from "../../components";
import { usCurrency, usDateFormat } from "../../utils";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

const CompletedLoansTile = (props) => {
  const {
    loanId,
    loanStatus,
    loanType,
    loanAmount,
    dateOfRequest,
    lastPaidDate,
    loanIdentifier,
    repaidAmount,
  } = props;

  return (
    <div className="d-flex align-items-baseline completed-loan-tile w-100">
      <div className="loan-border-right pr-3 w-35">
        <span className="ft-14 fw-500">{loanType}</span>
        <p className="ft-12 fw-500 m-0 active-status">
          <FontAwesomeIcon icon={faCheck} className="" /> Completely Paid
        </p>
        <p className="ft-12 m-0 card-text-color">
          {usDateFormat(dateOfRequest)}
        </p>
      </div>
      <div className="d-flex pl-3 w-65">
        <div className="w-20">
          <span className="ft-12 card-text-color mb-1">Loan Id</span>
          <p className="ft-12 fw-500 mb-1">{loanIdentifier ?? "-"}</p>
        </div>
        <div className="w-20">
          <span className="ft-12 card-text-color mb-1">Loan Amount</span>
          <p className="ft-12 fw-500 mb-1">{usCurrency(loanAmount)}</p>
        </div>
        <div className="w-30">
          <span className="ft-12 card-text-color mb-1">Repaid Amount</span>
          <p className="ft-12 fw-500 mb-1">{usCurrency(repaidAmount)}</p>
        </div>
        <div className="w-30">
          <span className="ft-12 card-text-color mb-1">Last Paid Date</span>
          <p className="ft-12 fw-500 mb-1">{usDateFormat(lastPaidDate)}</p>
        </div>
      </div>
    </div>
  );
};

export default CompletedLoansTile;
